import { render, staticRenderFns } from "./UserLoginsModal.vue?vue&type=template&id=39f1fd87&"
import script from "./UserLoginsModal.vue?vue&type=script&lang=js&"
export * from "./UserLoginsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports